import { api } from './api'
import type { PaginationMeta, Resolution } from '@riverpark/types'

export interface ListResolutionsFilters {
  page?: number
  limit?: number
}

export async function listResolutions(
  filters: ListResolutionsFilters = {},
): Promise<{ data: Resolution[]; meta: PaginationMeta }> {
  const params = new URLSearchParams()
  if (filters.page) params.set('page', String(filters.page))
  if (filters.limit) params.set('limit', String(filters.limit))
  const query = params.toString()
  return api.get<{ data: Resolution[]; meta: PaginationMeta }>(
    `/resolutions${query ? `?${query}` : ''}`,
  )
}

export async function getResolution(id: string): Promise<{ data: Resolution }> {
  return api.get<{ data: Resolution }>(`/resolutions/${id}`)
}

export interface CreateResolutionInput {
  title: string
  body: string
  pollId?: string
  /** ISO datetime string — omit for a brand-new resolution (defaults to now). */
  passedAt?: string
}

export type UpdateResolutionInput = Partial<CreateResolutionInput>

export async function createResolution(
  input: CreateResolutionInput,
): Promise<{ data: { id: string } }> {
  return api.post<{ data: { id: string } }>('/resolutions', input)
}

export async function updateResolution(
  id: string,
  input: UpdateResolutionInput,
): Promise<{ data: { success: boolean } }> {
  return api.patch<{ data: { success: boolean } }>(`/resolutions/${id}`, input)
}

export async function deleteResolution(id: string): Promise<{ data: { success: boolean } }> {
  return api.delete<{ data: { success: boolean } }>(`/resolutions/${id}`)
}
